import { getInfo, login, logout } from "@/api/user";
import { getToken, removeToken, setToken } from "@/utils/auth";
import { resetRouter } from "@/router";

const state = {
  token: getToken(),
  name: "",
  avatar: "",
  introduction: "",
  roles: [],
  userInfo: {},
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USER_ID: (state, userid) => {
    state.userInfo.userid = userid;
  },
  SET_USER: (state, userInfo) => {
    state.userInfo = userInfo;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then((response) => {
          const data = response.data;
          commit("SET_TOKEN", data.token);
          // commit('SET_USER_ID',data.userid)
          setToken(data.token);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then((data) => {
          if (data.code != 200) {
            reject("Verification failed, please Login again.");
          }

          commit("SET_USER", data.data);
          sessionStorage.setItem(
            "permissions",
            JSON.stringify(data.data.menuPermissions || "[]")
          );
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout()
        .then((response) => {
          if (response.code == 200) {
            commit("SET_TOKEN", "");
            removeToken();
            resetRouter();
            sessionStorage.removeItem("permissions");
            dispatch("tagsView/delAllViews", null, { root: true });
            dispatch("permission/removeRoutes", null, { root: true });
            // window.location.href = response.redirectURL;
            resolve();
          } else {
            resolve(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", "");
      removeToken();
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
